{
  "version": 1,
  "asset_id": "0fa1f14e-31d2-4734-8cb1-182598b18f72",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/0fa1f14e-31d2-4734-8cb1-182598b18f72/palworld-mobile-krafton-key-art.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/0fa1f14e-31d2-4734-8cb1-182598b18f72/palworld-mobile-krafton-key-art.webp",
  "original_filename": "palworld-mobile-krafton-key-art.webp",
  "size": 109566,
  "content_type": "image/webp",
  "created_at": "2026-09-23T15:14:53Z"
}
